import React,  { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import './../../css/AdminNavbar.css';
import { Link } from 'react-router-dom';
import Logo from './../../images/9r.png'

export default function Navbar() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = () => {
    const auth = getAuth();

    signOut(auth)
      .then(() => {
        console.log('User logged out successfully');
        setUser(null);
      })
      .catch((error) => {
        console.error('Error logging out: ', error);
      });
  };
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light " style={{overflowY: 'scroll'}}>
      <div className="container-fluid">
        <div className="d-flex">
          <Link className="navbar-brand d-flex flex-column" to="/" style={{ textDecoration: "none", textAlign: "left" }}>
            <img src={Logo} alt="" style={{ width: "80%" }} />
            <span className="unbounded px-2" style={{ textDecoration: "none", textAlign: "left" }}>
              FOR ADMIN
            </span>
          </Link>
          <button onClick={handleLogout} className="mt-3 px-2 d-flex align-items-center justify-content-between" style={{width: 'fit-content'}}>
              <svg className='mx-2' stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 0 1-112.7 75.9A352.8 352.8 0 0 1 512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 0 1-112.7-75.9 353.28 353.28 0 0 1-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z"></path></svg>
             <span>Logout</span>
          </button>
        </div>
        
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <hr />
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav d-flex flex-column w-100">
            <li className="nav-item">
              <Link className="nav-link active unbounded" aria-current="page" to="/a/dashboard">Dashboard</Link>
            </li>
            
            <li className="nav-item">
              <Link className="nav-link unbounded" to="/a/orders">Orders</Link>
            </li>
            
           <hr />

            <li className="nav-item">
              <Link className="nav-link unbounded" to="/a/add-color">Colors</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link unbounded" to="/a/add-size">Sizes</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link unbounded" to="/a/add-category">Categories</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link unbounded" to="/a/add-sub-category">Sub-Categories</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link unbounded" to="/a/add-gender">Genders</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link unbounded" to="/a/add-collection">Collections</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link unbounded" to="/a/add-season">Season</Link>
            </li>
            
            <hr />

            <li className="nav-item">
              <Link className="nav-link unbounded" to="/a/all-products">All Products</Link>
            </li>
            
            <li className="nav-item">
              <Link className="nav-link unbounded" to="/a/add-product">Add Product</Link>
            </li>
          </ul>
        </div>



        
      </div>
    </nav>
  )
}
